<template>
	<v-container>
		<v-app-bar app color="red">
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>

			<v-toolbar-title class="white--text">
				<span class="d-none d-sm-inline" v-if="obra && obra.id">Detalhes da </span>
				<span class="d-none d-sm-inline" v-else>Nova</span>
				Obra
			</v-toolbar-title>
		</v-app-bar>

		<!-- dados da obra -->
		<v-row>
			<!-- <v-col class="pt-0 pb-0" cols="12" md="2" sm="4">
				<v-text-field
					v-model="anoExercicio"
					:rules="[
						$rules.required(), 
						$rules.between(intervaloAno)
					]"
					label="Ano Exercício"
					required
					type="number"
					disabled
				/>
			</v-col> -->
			
			<v-col class="pt-0 pb-0" cols="12" md="2" sm="4">
				<v-text-field
					v-model="numeroObra"
					:rules="[
						$rules.required(),
						v => (v < 0 ? 'Valor deve ser maior que zero.' : true)
					]"
					label="Nr. Obra"
					required
					type="number"
					autofocus
				/>
			</v-col>

			<v-col class="pt-0 pb-0" cols="12" md="2" sm="4">
				<v-text-field
					v-model="dataPrevistaInauguracao"
					:rules="[$rules.required(),
							$rules.validDate()]"
					v-mask="'##/##/####'"
					label="Data Prevista de Inauguração"
					required
					autofocus
				/>
			</v-col>
		</v-row>

		<v-app-bar color="red lighten-4" >

			<v-tabs v-model="tab" centered color="red darken-4" icons-and-text>
				<v-tabs-slider></v-tabs-slider>

				<v-tab href="#tabEmendas">
					Emendas
					<v-icon>mdi-cash-multiple</v-icon>   <!-- ver ícone -->
				</v-tab>

				<v-tab href="#tabAndamentos">
					Andamentos
					<v-icon>mdi-cash</v-icon>	<!-- ver ícone -->
				</v-tab>

				<v-tab href="#tabAditivos">
					Aditivos
					<v-icon>mdi-cash</v-icon>	<!-- ver ícone -->
				</v-tab>
			</v-tabs>

		</v-app-bar>

		<v-card tile>
			<v-container>
				
				<v-obra-form
					v-model="obra"
					:tab="tab"
					@salvando="v => (salvarLoading = v)"
					@removendo="v => (removerLoading = v)"
					@saved="salvo"
					@updated="salvo"
					ref="obraForm"
					@snack="v => this.$emit('snack',v)"
				/>

				<!-- rodapé - valores totais -->
				<!-- <v-row>
					<v-col md="3">
						<v-text-field
							class="centered-input"
							label="Valor Total Anulado"
							:value="valorTotalAnulado$"
							placeholder="0"
							filled
							rounded
							dense
							readonly
						/>
					</v-col>
					<v-col md="3">
						<v-text-field
							class="centered-input"
							label="Valor Total Suplementado"
							:value="valorTotalSuplementado$"
							placeholder="0"
							filled
							rounded
							dense
							readonly
						/>
					</v-col>
					<v-col md="3">
						<v-text-field
							:class="[
								'centered-input',
								diferencaDotacao < 0 ? 'verde' : '',
								diferencaDotacao > 0.001 ? 'vermelho' : ''
							]"
							label="Diferença"
							:value="diferencaDotacao$"
							placeholder="0"
							filled
							rounded
							dense
							readonly
						/>
					</v-col>
				</v-row> -->

			</v-container>
		</v-card>

		<v-row> 
			<!-- <v-col>
				<v-btn color="primary" v-if="decreto && decreto.id" @click="imprimirDecreto(decreto.id, decreto.numeroDecreto)">Imprimir Decreto</v-btn>
			</v-col> -->

			<v-col class="text-right" justify-end width="100%">

				<v-btn text class="mr-5" @click="cancelar">Cancelar</v-btn>
				<v-dialog
					v-model="dialog"
					persistent
					max-width="350"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="mr-5"
							color="error"
							:loading="removerLoading"
							:disabled="removerLoading || formDesativado"
							@click="removerObra"
							v-bind="attrs"
							v-on="on"
							
						>
							Remover
						</v-btn>
					</template>
					<v-card>
						<v-card-title class="headline">
							Voce tem certeza disso?
						</v-card-title>
						<v-card-text v-if="obra">
							<p>
								Você confirma a exclusão da obra
								{{ obra.id }}?
							</p>
							<p>{{ obra.descricao }}</p>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text @click="cancelarRemocao">
								Cancelar
							</v-btn>
							<v-btn color="error" text @click="confirmarRemocao">
								Confirmar
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-btn
					color="primary"
					:loading="salvarLoading"
					:disabled="salvarLoading || formDesativado"
					@click="salvarobra"
				>
					Salvar
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { getYear } from 'date-fns';
import VObraForm from '@/forms/ObraForm.vue';
import { Vue } from '@/main';
//import _ from 'lodash';

export default {
	components: { VObraForm },
	data() {
		return {
			pesqEmenda: false,
			obra: null,
			id: null,
			numeroObra: null,
			dataPrevistaInauguracao: null,
			emendasObra: [],
			andamentosObra: [],
			numeroEmenda: null,
			anoExercicio: null,
			valor: 0,
			//dotacoesDecreto: [],
			//dotacoesEmenda: [],
			salvarLoading: false,
			removerLoading: false,
			dialog: false,
			tab: 'tabEmendas',
			esferaItems: [],
			intervaloAno: {
				start: 1900,
				end: getYear(new Date()) + 4,
				msg: 'Ano inválido. Deve ser entre ${start} e ${end}'
			},
			descrEsfera : null
		};
	},

	watch: { 
		id(value) {
			if (this.obraForm) {
				this.obraForm.id = value;
			}
		},

		dataPrevistaInauguracao(value) {
			if (this.obraForm) {
				this.obraForm.dataPrevistaInauguracao = value;
			}
		},

		numeroObra(value) {
			if (this.obraForm) {
				this.obraForm.numeroObra = value;
			}
		},

		emendasObra(value) {
			if (this.obraForm) {
				this.obraForm.emendasObra = value;
			}
		},

		andamentosObra(value) {
			if (this.obraForm) {
				this.obraForm.andamentosObra = value;
			}
		}

		// anoExercicio(value) {
		// 	if (this.decretoForm) {
		// 		this.decretoForm.anoExercicio = value;
		// 	}
		// },

		// valor(value) {
		// 	if (this.decretoForm) {
		// 		this.decretoForm.valor = value;
		// 	}
		// },

		// dotacoesEmenda(value) {
		// 	if (this.decretoForm) {
		// 		this.decretoForm.dotacoesEmenda = value;
		// 	}
		// }

	},

	computed: {
		obraForm() {
			let ComponentClass = Vue.extend(VObraForm);
			let obraForm = new ComponentClass();
			if (this.obra && this.$refs && this.$refs.obraForm) {
				return this.$refs.obraForm;
			} else {
				return obraForm;
			}
		},

		formDesativado() {
			if (this.$root.usuarioLogado &&
					this.$root.usuarioLogado.funcoes &&
					this.$root.usuarioLogado.funcoes.includes('OBRA_ALTERAR')) {
				return false;
			// } else if (this.decreto && this.decreto.decretoSituacao && this.decreto.decretoSituacao.id === 3) {
			// 	return false;
			} else {
				return true;
			}
		},

		// valorTotalAnulado() {
		// 	if (this.decretoForm.dotacoesDecretoAnular && this.decretoForm.dotacoesDecretoAnular.length > 0) {
		// 		return this.decretoForm.dotacoesDecretoAnular.reduce((a, b) => a + (parseFloat(b.valorAnulado) || 0), 0);
		// 	} else {
		// 		return 0;
		// 	}
		// },
		
		// valorTotalAnulado$() {
		// 	return this.setMascara(this.valorTotalAnulado);
		// },

		// valor$() {
		// 	return this.setMascara(this.valor);
		// },

		// valorTotalSuplementado() {
		// 	if (this.decretoForm.dotacoesDecretoSuplementar && this.decretoForm.dotacoesDecretoSuplementar.length > 0) {
		// 		return this.decretoForm.dotacoesDecretoSuplementar.reduce((a, b) => a + (parseFloat(b.valorSuplementado) || 0), 0);
		// 	} else {
		// 		return 0;
		// 	}
		// },
		
		// valorTotalSuplementado$() {
		// 	return this.setMascara(this.valorTotalSuplementado);
		// },

		// diferencaDotacao() {
		// 	return this.valorTotalAnulado - this.valorTotalSuplementado;
		// },
		
		// diferencaDotacao$() {
		// 	return this.setMascara(this.diferencaDotacao);
		// }

	},
	
	async created() {
		if (this.$route.params.id !== 'novo') {
			this.obra = await this.obraForm.obterObra(this.$route.params.id);
			this.id = this.obra.id;
			this.numeroObra = this.obra.numeroObra;
			this.dataPrevistaInauguracao = this.obra.dataPrevistaInauguracao;
			this.emendasObra = this.obra.emendasObra;
			this.andamentosObra = this.obra.andamentosObra;
		}
		// else {
		// 	// novo decreto
		// 	this.anoExercicio = this.$root.anoSelecionado;
		// }
		
	},

	methods: {
		async salvarobra() {
			await this.obraForm.salvar();
		},

		// exibirTramitar() {
		// 	this.decretoForm.exibirTramitar();
		// },
		
		async removerObra() {
			this.dialog = true;
		},

		cancelar() {
			this.$router.replace('/obras');
		},

		async confirmarRemocao() {
			let obraRemovida = await this.obraForm.remover();
			
			//if (obraRemovida && obraRemovida.id) {	
			if (obraRemovida) {
				this.$emit('snack', {
					show: true,
					text: `Obra removida com sucesso`
				});
				this.$router.replace('/obras');
			}
			this.dialog = false;
		},
		
		cancelarRemocao() {
			this.dialog = false;
		},
		
		salvo(obraSalva) {
			if (obraSalva && obraSalva.id) {
				this.$emit('snack', {
					show: true,
					text: `Obra ${obraSalva.numeroObra} salva com sucesso`
				});
				this.$router.replace('/obras');
			}
		},

		// setMascara(v) {
		// 	return parseFloat(v).toLocaleString('pt-BR', {
		// 		minimumFractionDigits: 2,
		// 		maximumFractionDigits: 2,
		// 		style: 'currency',
		// 		currency: 'BRL'
		// 	});
		// },

		// imprimirDecreto(id, numeroDecreto) {
		// 	var url = `api/decretos/${id}/imprimir`;
		// 	var fileName = `Decreto ${numeroDecreto}.pdf`;
		// 	var link = document.createElement('a');
		// 	link.href = url;
		// 	link.download = fileName;
		// 	document.body.appendChild(link);
		// 	link.click();
		// 	document.body.removeChild(link);
		// }

	}
};
</script>

<style scoped>
.verde >>> .v-input__slot {
	background-color: #95ff9d !important;
}

.label-cinza {
	-webkit-text-size-adjust: 100%;
    word-break: normal;
    tab-size: 4;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-family: "Roboto", sans-serif;
    letter-spacing: normal;
    text-align: left;
    background-repeat: no-repeat;
    box-sizing: inherit;
    padding: 0;
    margin: 0;
    font-size: 13px;
    min-height: 8px;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    overflow: hidden;
    text-overflow: ellipsis;
    top: 6px;
    white-space: nowrap;
    pointer-events: none;
    max-width: 133%;
    transform: translateY(-18px) scale(0.75);
    height: 16px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.6);
    transform-origin: top left;
    left: 0px;
    right: auto;
	font-family: Roboto, sans-serif;
	text-size-adjust: 100%;
    /* position: absolute; */
}
</style>